import { combineEpics } from "redux-most";
import * as steps from "common/steps";
import * as termsActions from "./termsActions";
import * as submissionActions from "submission/submissionActions";
import {
  getStepAcceptedOptIns,
  getStepDeclinedOptIns,
  getStepFields,
  isStepCompleted,
} from "common/selectors";
import {
  createSyncLocalStorageEpic,
  createLoadLocalStorageEpic,
  createAcknowledgeSubmissionEpic,
} from "common/stepEpicCommon";

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
    submissionActions.ADD_ANOTHER_WORK,
    submissionActions.CANCEL_SUBMISSION,
    submissionActions.SUBMIT,
    termsActions.ACCEPT_OPT_IN,
    termsActions.COMPLETE_STEP,
    termsActions.DECLINE_OPT_IN,
  ],
  {
    completed: isStepCompleted(steps.TERMS),
    fields: getStepFields(steps.TERMS),
    acceptedOptIns: getStepAcceptedOptIns(steps.TERMS),
    declinedOptIns: getStepDeclinedOptIns(steps.TERMS),
  },
  termsActions.localStorageSynced,
  steps.TERMS,
);

export default combineEpics([
  createLoadLocalStorageEpic(steps.TERMS, termsActions.localStorageLoaded),
  syncLocalStorageEpic,
  createAcknowledgeSubmissionEpic(steps.TERMS),
]);
